'use strict';
import * as $j_app$002edata$002e$002dApp$002dUser$002dEmail from "./app.data.-App-User-Email.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppUserEmail$Pharmacy(email) {
  this.Lapp_data_AppUserEmail$Pharmacy__f_email = null;
  this.Lapp_data_AppUserEmail$Pharmacy__f_email = email;
}
export { $c_Lapp_data_AppUserEmail$Pharmacy as $c_Lapp_data_AppUserEmail$Pharmacy };
$c_Lapp_data_AppUserEmail$Pharmacy.prototype = new $j_app$002edata$002e$002dApp$002dUser$002dEmail.$h_Lapp_data_AppUserEmail();
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.constructor = $c_Lapp_data_AppUserEmail$Pharmacy;
/** @constructor */
function $h_Lapp_data_AppUserEmail$Pharmacy() {
}
export { $h_Lapp_data_AppUserEmail$Pharmacy as $h_Lapp_data_AppUserEmail$Pharmacy };
$h_Lapp_data_AppUserEmail$Pharmacy.prototype = $c_Lapp_data_AppUserEmail$Pharmacy.prototype;
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 243544489, true);
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_AppUserEmail$Pharmacy) && (this.Lapp_data_AppUserEmail$Pharmacy__f_email === x$0.Lapp_data_AppUserEmail$Pharmacy__f_email)));
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.productPrefix__T = (function() {
  return "Pharmacy";
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppUserEmail$Pharmacy__f_email;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppUserEmail$Pharmacy.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppUserEmail$Pharmacy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppUserEmail$Pharmacy)));
}
export { $isArrayOf_Lapp_data_AppUserEmail$Pharmacy as $isArrayOf_Lapp_data_AppUserEmail$Pharmacy };
var $d_Lapp_data_AppUserEmail$Pharmacy = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppUserEmail$Pharmacy, "app.data.AppUserEmail$Pharmacy", ({
  Lapp_data_AppUserEmail$Pharmacy: 1,
  Lapp_data_AppUserEmail: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_AppUserEmail$Pharmacy as $d_Lapp_data_AppUserEmail$Pharmacy };
//# sourceMappingURL=app.data.-App-User-Email$-Pharmacy.js.map
